import { useState } from "react";

export type InteractionMode = "sticker" | "focus";

export const useInteractionMode = () => {
  const [mode, setMode] = useState<InteractionMode>("focus");

  const switchMode = (newMode: InteractionMode) => {
    setMode(newMode);
  };

  const toggleMode = () => {
    setMode((prev) => (prev === "focus" ? "sticker" : "focus"));
  };

  return {
    mode,
    switchMode,
    toggleMode,
    isFocus: mode === "focus",
    isSticker: mode === "sticker",
  };
};
